const updates = [
  {
    time: '15:42',
    content: '某知名导演新片拍摄现场剧照流出，主演阵容首次曝光引发影迷热议，票房预期被大幅调高。',
    tag: '影视',
  },
  {
    time: '14:18',
    content: '某男团成员被爆与女粉丝私下约会，公司紧急发声明称"纯属工作关系"，粉丝表态不一。',
    tag: '偶像',
  },
  {
    time: '12:55',
    content: '某头部主播直播时意外口误自爆收入，引发网友集体讨论网红经济，相关话题登上热搜。',
    tag: '直播',
  },
  {
    time: '11:30',
    content: '某女歌手新专辑上线12小时销量突破百万，被质疑刷榜，平台方已介入数据核查。',
    tag: '音乐',
  },
  {
    time: '09:47',
    content: '某综艺节目剪辑师离职后公开爆料：节目组刻意制造矛盾，多位艺人被恶意剪辑。',
    tag: '综艺',
  },
  {
    time: '08:15',
    content: '某网红餐饮品牌被暗访曝光后厨卫生问题，品牌连夜道歉并宣布全国门店停业整顿。',
    tag: '餐饮',
  },
  {
    time: '昨日 22:30',
    content: '某知名编剧疑似抄袭事件持续发酵，多位业内人士发声，相关作品播放平台已暂停推荐。',
    tag: '文娱',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            最新快讯
          </h2>
          <p className="mt-2 text-sm text-foreground-500">实时追踪全网娱乐热点动态</p>
        </div>
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-4 md:left-8 top-0 bottom-0 w-px bg-background-300/60"></div>
          <div className="space-y-0">
            {updates.map((update, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-8 pb-6 last:pb-0 pl-10 md:pl-16">
                {/* Timeline dot */}
                <div className="absolute left-3 md:left-[30px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 z-10"></div>
                {/* Time */}
                <div className="flex-shrink-0 w-16 md:w-20 text-right">
                  <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{update.time}</span>
                </div>
                {/* Content */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-start gap-2 flex-wrap">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100 rounded whitespace-nowrap">
                      {update.tag}
                    </span>
                    <p className="text-sm text-foreground-700 leading-relaxed">{update.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}